import React from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import Club from "./Club";
import dayjs from "dayjs";

const Game = ({ game, forceMobile = false }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')) || forceMobile;

    const homeExists = Boolean(game.homeClub);
    const awayExists = Boolean(game.awayClub);
    const homeAuxExist = homeExists && Boolean(game.homeClub.aux) && game.homeClub.aux.length > 1;
    const awayAuxExist = awayExists && Boolean(game.awayClub.aux) && game.awayClub.aux.length > 1;

    const homeScore = homeExists ? game.homeClub.score : null;
    const awayScore = awayExists ? game.awayClub.score : null;
    const isDecided = homeScore !== null && homeScore !== undefined && awayScore !== null && awayScore !== undefined && homeScore !== awayScore;
    const homeWins = isDecided && homeScore > awayScore;
    const awayWins = isDecided && awayScore > homeScore;

    const commonParams = { forceAuxSpace: homeAuxExist || awayAuxExist, showScore: isMobile };
    return (
        <Grid container textAlign="center" alignItems="center">
            <Grid item xs={5} textAlign="left">
                {
                    Boolean(game.echelon) ? (
                        <Typography fontSize="0.8em" fontWeight="bold" color={theme.palette.primary.dark}>{game.echelon.name}</Typography>
                    ) : null
                }
            </Grid>
            <Grid item xs={2}>
                <Box
                    component="span"
                    sx={{
                        display: "inline-block",
                        px: theme.spacing(2),
                        py: theme.spacing(1),
                        borderRadius: "999px",
                        backgroundColor: theme.palette.whiteSmoke.main,
                    }}
                >
                    <Typography color={theme.palette.davysGray.dark} fontSize="1rem" fontWeight="700">{dayjs(game.date).format("HH:mm")}</Typography>
                </Box>
            </Grid>
            <Grid item xs={5} textAlign="right">
                {
                    !isMobile && Boolean(game.competition) ? (
                        <Typography fontSize="0.9rem" fontStyle="italic">{game.competition.name}</Typography>
                    ) : null
                }
            </Grid>
            <Grid item xs={isMobile ? 6 : 4}>
                <Club club={game.homeClub} {...commonParams} highlight={homeWins} />
            </Grid>
            {
                !isMobile ? (
                    <React.Fragment>
                        <Grid item xs={1}>
                            {
                                Boolean(game.homeClub) ? (
                                    <Typography fontSize="2.4rem" fontWeight="bold" color={homeWins ? theme.palette.primary.dark : theme.palette.davysGray.main}>{game.homeClub.score}</Typography>
                                ) : null
                            }
                        </Grid>
                        <Grid item xs={2}>
                            <Typography fontSize="1.4rem" color={theme.palette.davysGray.light} fontWeight="300">–</Typography>
                        </Grid>
                        <Grid item xs={1}>
                            {
                                Boolean(game.awayClub) ? (
                                    <Typography fontSize="2.4rem" fontWeight="bold" color={awayWins ? theme.palette.primary.dark : theme.palette.davysGray.main}>{game.awayClub.score}</Typography>
                                ) : null
                            }
                        </Grid>
                    </React.Fragment>
                ) : null
            }
            <Grid item xs={isMobile ? 6 : 4}>
                <Club club={game.awayClub} {...commonParams} highlight={awayWins} />
            </Grid>
            {
                isMobile && Boolean(game.competition) ? (
                    <Grid item xs={12} mt={theme.spacing(2)}>
                        <Typography fontStyle="italic" fontSize="0.85rem">{game.competition.name}</Typography>
                    </Grid>
                ) : null
            }
            {
                Boolean(game.location) ? (
                    <Grid item xs={12} mt={theme.spacing(1)}>
                        <Typography fontSize="0.85rem" color={theme.palette.davysGray.main}>{game.location}</Typography>
                    </Grid>
                ) : null
            }
        </Grid>
    )
}

export default Game;
